import { useCallback } from "react";
import { useSelector } from "react-redux";
import type * as React from "react";
import { Box } from "@mui/material";
import { Model } from "survey-core";
import { getStandaloneSurveySlotSx } from "components/v3/layouts/StandaloneSurveyPageLayout";
import SurveyWrapper from "components/v3/sharedComponents/surveys/SurveyWrapper";
import { selectUserPersonalInformation } from "store/reducers/user/UserAccountSlice";

export const SURVEY_ID = "cologuard-personalized-resources-survey";

type CologuardPersonalizedResourcesSurveyProps = {
  onComplete: (surveyModel: Model) => void;
};

const CologuardPersonalizedResourcesSurvey = ({
  onComplete
}: CologuardPersonalizedResourcesSurveyProps): React.ReactElement => {
  const { email, phone } = useSelector(selectUserPersonalInformation);

  const handleOnComplete = (surveyModel: Model): void => {
    onComplete(surveyModel);
  };

  const handleOnSurveyInstantiated = useCallback(
    (surveyModel: Model): void => {
      surveyModel.pagePrevText = "Back";

      if (email) {
        surveyModel.setValue("preferred-contact-email-address", email);
      }
      if (phone) {
        surveyModel.setValue("preferred-contact-phone-number", phone);
      }
    },
    [email, phone]
  );

  return (
    <Box sx={getStandaloneSurveySlotSx(false)}>
      <SurveyWrapper
        containerClassName="cologuard-personalized-resources-survey-container"
        fillViewport
        focusFirstQuestionAutomatic={false}
        onComplete={handleOnComplete}
        onSurveyInstantiated={handleOnSurveyInstantiated}
        overrideNextButtonEnabled={true}
        surveyId={SURVEY_ID}
      />
    </Box>
  );
};

export default CologuardPersonalizedResourcesSurvey;
